import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeTranslationsLanguageComponent } from '@shared/modules/translations/components/change-translations-language/change-translations-language.component';
import { IconModule } from '@shared/modules/common/icon/icon.module';
import { LinkModule } from '@shared/ui/kit/link/link.module';

@NgModule({
  declarations: [ChangeTranslationsLanguageComponent],
  imports: [CommonModule, IconModule, LinkModule],
  exports: [ChangeTranslationsLanguageComponent]
})
export class ChangeTranslationsLanguageModule {}
